/* @generated */

// src/assets/ui-icon/line/thumbs-up.tsx
import * as React from "react";
var ThumbsUpLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M18.456 10.775A2.265 2.265 0 0 0 16.75 10h-2.1l.303-1.668A3.25 3.25 0 0 0 11.755 4.5h-1.09l-.991 3.965a.746.746 0 0 1-.342.462l-1.374.823a1.75 1.75 0 0 1-.9.25H5v6.713l3.886 1.944c.452.225.95.343 1.455.343h5.596a2.247 2.247 0 0 0 2.224-1.916l.832-4.534a2.24 2.24 0 0 0-.537-1.775Zm-.944 1.538-.832 4.537a.75.75 0 0 1-.743.65H10.34c-.272 0-.54-.064-.783-.185L6.5 15.786V11.5h.558a3.25 3.25 0 0 0 1.671-.463l1.374-.824a2.234 2.234 0 0 0 1.026-1.384L11.835 6a1.75 1.75 0 0 1 1.641 2.061L12.85 11.5h3.9a.767.767 0 0 1 .577.263.72.72 0 0 1 .185.55Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ThumbsUpLine
};
